import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { focus } from "@/data/site";
import { FadeUp, Stagger } from "@/components/motion/Reveal";

export const Focus = ({ detailed = false }) => (
  <section id="leistungen" data-testid="services-section" className="section border-t hairline">
    <div className="container-x">
      <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-12">
        <FadeUp>
          <p className="eyebrow mb-4">Leistungen</p>
          <h2 className="h-section">Was wir für Ihr Auto tun.</h2>
        </FadeUp>
        {!detailed && (
          <FadeUp delay={0.1}>
            <Link to="/leistungen" data-testid="services-all-link" className="inline-flex items-center gap-2 text-[color:var(--ink-2)] hover:text-[color:var(--ink)] link-underline">Alle Leistungen <ArrowRight className="h-4 w-4" /></Link>
          </FadeUp>
        )}
      </div>
      <Stagger className="grid md:grid-cols-3 gap-4 md:gap-5" gap={0.08}>
        {focus.map((f) => (
          <div key={f.slug}>
            <Link to={`/leistungen/${f.slug}`} data-testid={`service-feature-${f.slug}`} className="panel group block h-full p-7 md:p-8 hover:border-[color:var(--ink-3)] transition-colors duration-300">
              <h3 className="h-sub">{f.title}</h3>
              <p className="mt-3 text-[color:var(--ink-2)] leading-relaxed">{detailed ? f.long : f.d}</p>
              <span className="mt-6 inline-flex items-center gap-2 text-[15px] text-[color:var(--violet)]">Mehr erfahren <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" /></span>
            </Link>
          </div>
        ))}
      </Stagger>
    </div>
  </section>
);
